/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from "./App.vue"

// Styles
import "@/assets/main.css"

// Composables
import { createApp } from "vue"
import { useAppConfigStore } from "@/stores/appConfig"

// Plugins
import { registerPlugins } from "@/plugins"

// MsalApi
import { AuthService } from "@/services/AuthService"

// AWS Connect
import { AwsConnect3pService } from "@/services/AwsConnect3pService"

import { errorReporter } from "@/services/ErrorService"

// Console log application information
import { spaceLogger } from "@/theme/spaceLogger"

if (__APP_VERCEL_ENV__ === "preview" || import.meta.env.DEV) {
  const { HeaderInjector } = await import("@soenergy/header-injector")
  HeaderInjector.init({
    appendToEl: "#app-wrapper .v-application__wrap",
    scopeKey: __APP_VERCEL_BRANCH__ || "local",
    defaultHeaderValue: import.meta.env.SO_X_BRANCH_NAME,
    apiUrls: [
      import.meta.env.SO_API_GATEWAY_URL,
      import.meta.env.SO_BACKOFFICE_GATEWAY_URL,
    ],
  })
}

spaceLogger([
  { text: "Environment: " },
  { text: import.meta.env.MODE, isSecondary: true, addNewLine: true },
  { text: "App Version: " },
  { text: __APP_VERSION__, isSecondary: true, addRocket: true },
])

const app = createApp(App)
registerPlugins(app)

const appConfigStore = useAppConfigStore()

// Authentication service must be initialized after plugins
const initAuthService = (usePopupApi = false) => {
  AuthService.init({ usePopupApi: usePopupApi })
}

AwsConnect3pService.activate()
  .then((isAwsConnect3pApp) => {
    appConfigStore.setAppLayout(isAwsConnect3pApp ? "compact" : "default")
    initAuthService(isAwsConnect3pApp)
  })
  .catch((error) => {
    console.error(error)
    errorReporter.report(error)
    appConfigStore.setAppLayout("default")
    initAuthService()
  })

app.mount("#app")
